import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { useRealtimeRefresh } from '../../hooks/useRealtimeRefresh';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Badge } from '../../components/ui/badge';
import { toast } from 'sonner';
import { 
  Plus, 
  Search, 
  Trash2, 
  Building2, 
  Package, 
  PackagePlus,
  Upload,
  FileText,
  X,
  Check,
  Pencil,
  Eye,
  Lock,
  ArrowUpDown,
  ArrowUp,
  ArrowDown,
  Download,
  Calendar,
  Filter,
  Info
} from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const DepotEntry = ({ branchIdOverride, readOnly = false }) => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('cari');
  
  // Bilgilendirme kutusu state'leri (localStorage'dan oku)
  const [showCariInfo, setShowCariInfo] = useState(() => {
    return localStorage.getItem('depot_cari_info_hidden') !== 'true';
  });
  const [showStokGirisiInfo, setShowStokGirisiInfo] = useState(() => {
    return localStorage.getItem('depot_stok_girisi_info_hidden') !== 'true';
  });
  
  // Cari Hesap State
  const [cariHesaplar, setCariHesaplar] = useState([]);
  const [cariSearch, setCariSearch] = useState('');
  const [cariModal, setCariModal] = useState(false);
  const [cariForm, setCariForm] = useState({ name: '', city: '', phone: '' });
  
  // Cari Hesap Gelişmiş Filtreleme State
  const [allCariProducts, setAllCariProducts] = useState([]);
  const [cariFilterOptions, setCariFilterOptions] = useState({
    product_names: [],
    cari_names: [],
    cities: [],
    statuses: []
  });
  const [cariFilters, setCariFilters] = useState({
    product: '',
    company: '',
    city: '',
    status: 'all'
  });
  const [showCariFilters, setShowCariFilters] = useState(false);
  const [cariProductsLoading, setCariProductsLoading] = useState(false);
  
  // Stok Kartı State
  const [stokKartlari, setStokKartlari] = useState([]);
  const [stokSearch, setStokSearch] = useState('');
  const [stokModal, setStokModal] = useState(false);
  const [stokForm, setStokForm] = useState({ product_name: '', model: '', features: '', unit: 'adet', minimum_stock: '', max_usage: '' });
  
  // Stok Ekle State
  const [stokEkleModal, setStokEkleModal] = useState(false);
  const [stokEkleForm, setStokEkleForm] = useState({
    cari_hesap_id: '',
    items: [{ stok_karti_id: '', quantity: '', unit: '' }],
    documents: [],
    description: ''
  });
  const [cariSearchInput, setCariSearchInput] = useState('');
  const [stokSearchInput, setStokSearchInput] = useState('');
  const [filteredCari, setFilteredCari] = useState([]);
  const [filteredStok, setFilteredStok] = useState([]);
  const [showCariDropdown, setShowCariDropdown] = useState(false);
  const [showStokDropdown, setShowStokDropdown] = useState([]);
  const [selectedCariName, setSelectedCariName] = useState('');
  
  // Stok Girişleri State
  const [stokGirisleri, setStokGirisleri] = useState([]);
  const [stokGirisiSearch, setStokGirisiSearch] = useState('');
  const [stokGirisiSort, setStokGirisiSort] = useState({ column: 'date', direction: 'desc' });
  const [stokGirisiDateFilter, setStokGirisiDateFilter] = useState({ startDate: '', endDate: '' });
  
  // Edit States
  const [editCariModal, setEditCariModal] = useState(false);
  const [editCariForm, setEditCariForm] = useState({ id: '', name: '', city: '', phone: '' });
  const [editStokModal, setEditStokModal] = useState(false);
  const [editStokForm, setEditStokForm] = useState({ id: '', product_name: '', model: '', features: '', unit: 'adet', minimum_stock: '', max_usage: '' });
  
  // Detail View State
  const [detailModal, setDetailModal] = useState(false);
  const [detailData, setDetailData] = useState(null);
  
  // Ürün Giriş Geçmişi Modal State
  const [productHistoryModal, setProductHistoryModal] = useState(false);
  const [selectedProductHistory, setSelectedProductHistory] = useState({ product_name: '', entries: [] });
  
  // Cari Hesap Detay State (Gelecek Ürünler)
  const [selectedCariDetail, setSelectedCariDetail] = useState(null);
  const [cariDetailLoading, setCariDetailLoading] = useState(false);
  const [cariGelecekUrunler, setCariGelecekUrunler] = useState([]);
  
  // Şifre Doğrulama State
  const [passwordModal, setPasswordModal] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const [pendingAction, setPendingAction] = useState(null);
  const EDIT_DELETE_PASSWORD = 'Alyatugba21';

  // Şifre ile işlem başlatma
  const requestPasswordForAction = (action, data) => {
    setPendingAction({ action, data });
    setPasswordInput('');
    setPasswordModal(true);
  };

  // Şifre doğrulama ve işlem yürütme
  const handlePasswordConfirm = () => {
    if (passwordInput !== EDIT_DELETE_PASSWORD) {
      toast.error('Şifre yanlış!');
      return;
    }
    
    setPasswordModal(false);
    setPasswordInput('');
    
    if (pendingAction) {
      const { action, data } = pendingAction;
      switch (action) {
        case 'deleteCari':
          executeDeleteCari(data);
          break;
        case 'editCari':
          executeEditCari(data);
          break;
        case 'deleteStokKarti':
          executeDeleteStokKarti(data);
          break;
        case 'editStokKarti':
          executeEditStokKarti(data);
          break;
        case 'deleteStokGirisi':
          executeDeleteStokGirisi(data);
          break;
        default:
          break;
      }
      setPendingAction(null);
    }
  };

  const getAuthHeaders = () => ({
    'Authorization': `Bearer ${localStorage.getItem('fortis_token')}`,
    'Content-Type': 'application/json'
  });

  // Fetch Data - GLOBAL endpoints for shared data
  const fetchCariHesaplar = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/global/cari-hesaplar`, { headers: getAuthHeaders() });
      setCariHesaplar(res.data);
    } catch (err) {
      console.error('Cari hesaplar yüklenemedi:', err);
    }
  }, []);

  const fetchStokKartlari = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/global/stok-kartlari`, { headers: getAuthHeaders() });
      setStokKartlari(res.data);
    } catch (err) {
      console.error('Stok kartları yüklenemedi:', err);
    }
  }, []);

  const fetchStokGirisleri = useCallback(async () => {
    try {
      const branchParam = branchIdOverride ? `?branch_id=${branchIdOverride}` : '';
      const res = await axios.get(`${API}/api/depot/stok-girisleri${branchParam}`, { headers: getAuthHeaders() });
      setStokGirisleri(res.data);
    } catch (err) {
      console.error('Stok girişleri yüklenemedi:', err);
    }
  }, [branchIdOverride]);

  // Tüm cari ürünleri filtreleme için yükle
  const fetchAllCariProducts = useCallback(async () => {
    setCariProductsLoading(true);
    try {
      const branchParam = branchIdOverride ? `?branch_id=${branchIdOverride}` : '';
      const res = await axios.get(`${API}/api/depot/cari-urunler-tumu${branchParam}`, { headers: getAuthHeaders() });
      setAllCariProducts(res.data.products || []);
      setCariFilterOptions(res.data.filter_options || {
        product_names: [],
        cari_names: [],
        cities: [],
        statuses: []
      });
    } catch (err) {
      console.error('Cari ürünler yüklenemedi:', err);
    }
    setCariProductsLoading(false);
  }, [branchIdOverride]);

  // Cari hesaptan gelen ürünleri yükle
  const fetchCariGelecekUrunler = async (cariId, cariName) => {
    if (selectedCariDetail === cariId) {
      // Aynı cari hesaba tıklandıysa kapat
      setSelectedCariDetail(null);
      setCariGelecekUrunler([]);
      return;
    }
    
    setCariDetailLoading(true);
    setSelectedCariDetail(cariId);
    try {
      const res = await axios.get(`${API}/api/depot/gelecek-urunler/by-cari/${cariId}`, { headers: getAuthHeaders() });
      setCariGelecekUrunler(res.data || []);
    } catch (err) {
      console.error('Cari gelecek ürünler yüklenemedi:', err);
      setCariGelecekUrunler([]);
    }
    setCariDetailLoading(false);
  };

  useEffect(() => {
    fetchCariHesaplar();
    fetchStokKartlari();
    fetchStokGirisleri();
    fetchAllCariProducts();
  }, [fetchCariHesaplar, fetchStokKartlari, fetchStokGirisleri, fetchAllCariProducts]);

  // Gerçek zamanlı: veri değişince listeleri otomatik yenile
  useRealtimeRefresh(() => {
    fetchStokGirisleri();
    fetchAllCariProducts();
    if (selectedCariDetail) {
      axios.get(`${API}/api/depot/gelecek-urunler/by-cari/${selectedCariDetail}`, { headers: getAuthHeaders() })
        .then(res => setCariGelecekUrunler(res.data || []))
        .catch(() => {});
    }
  });

  // Cari Hesap CRUD
  const handleCreateCari = async () => {
    if (!cariForm.name) {
      toast.error('Cari hesap adı zorunludur');
      return;
    }
    try {
      await axios.post(`${API}/api/global/cari-hesaplar`, cariForm, { headers: getAuthHeaders() });
      toast.success('Cari hesap oluşturuldu');
      setCariModal(false);
      setCariForm({ name: '', city: '', phone: '' });
      fetchCariHesaplar();
    } catch (err) {
      toast.error('Cari hesap oluşturulamadı');
    }
  };

  const handleDeleteCari = async (id) => {
    requestPasswordForAction('deleteCari', id);
  };

  const executeDeleteCari = async (id) => {
    try {
      await axios.delete(`${API}/api/global/cari-hesaplar/${id}`, { headers: getAuthHeaders() });
      toast.success('Cari hesap silindi');
      fetchCariHesaplar();
    } catch (err) {
      toast.error('Cari hesap silinemedi');
    }
  };

  const openEditCari = (cari) => {
    requestPasswordForAction('editCari', cari);
  };

  const executeEditCari = (cari) => {
    setEditCariForm({ id: cari.id, name: cari.name, city: cari.city || '', phone: cari.phone || '' });
    setEditCariModal(true);
  };

  const handleUpdateCari = async () => {
    if (!editCariForm.name) {
      toast.error('Cari hesap adı zorunludur');
      return;
    }
    try {
      await axios.put(`${API}/api/global/cari-hesaplar/${editCariForm.id}`, editCariForm, { headers: getAuthHeaders() });
      toast.success('Cari hesap güncellendi');
      setEditCariModal(false);
      fetchCariHesaplar();
    } catch (err) {
      toast.error('Cari hesap güncellenemedi');
    }
  };

  // Stok Kartı CRUD
  const handleCreateStokKarti = async () => {
    if (!stokForm.product_name) {
      toast.error('Ürün adı zorunludur');
      return;
    }
    try {
      await axios.post(`${API}/api/global/stok-kartlari`, stokForm, { headers: getAuthHeaders() });
      toast.success('Stok kartı oluşturuldu');
      setStokModal(false);
      setStokForm({ product_name: '', model: '', features: '', unit: 'adet', minimum_stock: '', max_usage: '' });
      fetchStokKartlari();
    } catch (err) {
      toast.error('Stok kartı oluşturulamadı');
    }
  };

  const handleDeleteStokKarti = async (id) => {
    requestPasswordForAction('deleteStokKarti', id);
  };

  const executeDeleteStokKarti = async (id) => {
    try {
      await axios.delete(`${API}/api/global/stok-kartlari/${id}`, { headers: getAuthHeaders() });
      toast.success('Stok kartı silindi');
      fetchStokKartlari();
    } catch (err) {
      toast.error('Stok kartı silinemedi');
    }
  };

  const openEditStok = (stok) => {
    requestPasswordForAction('editStokKarti', stok);
  };

  const executeEditStokKarti = (stok) => {
    setEditStokForm({ 
      id: stok.id, 
      product_name: stok.product_name, 
      model: stok.model || '', 
      features: stok.features || '', 
      unit: stok.unit,
      minimum_stock: stok.minimum_stock || '',
      max_usage: stok.max_usage || ''
    });
    setEditStokModal(true);
  };

  const handleUpdateStokKarti = async () => {
    if (!editStokForm.product_name) {
      toast.error('Ürün adı zorunludur');
      return;
    }
    try {
      await axios.put(`${API}/api/global/stok-kartlari/${editStokForm.id}`, editStokForm, { headers: getAuthHeaders() });
      toast.success('Stok kartı güncellendi');
      setEditStokModal(false);
      fetchStokKartlari();
    } catch (err) {
      toast.error('Stok kartı güncellenemedi');
    }
  };

  const openDetailModal = (giris) => {
    setDetailData(giris);
    setDetailModal(true);
  };

  // Stok Ekle
  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    files.forEach(file => {
      const reader = new FileReader();
      reader.onload = () => {
        setStokEkleForm(prev => ({
          ...prev,
          documents: [...prev.documents, {
            name: file.name,
            type: file.type,
            data: reader.result
          }]
        }));
      };
      reader.readAsDataURL(file);
    });
  };

  const removeDocument = (index) => {
    setStokEkleForm(prev => ({
      ...prev,
      documents: prev.documents.filter((_, i) => i !== index)
    }));
  };

  const addNewItem = () => {
    setStokEkleForm(prev => ({
      ...prev,
      items: [...prev.items, { stok_karti_id: '', quantity: '', unit: '' }]
    }));
    setShowStokDropdown(prev => [...prev, false]);
  };

  const removeItem = (index) => {
    if (stokEkleForm.items.length === 1) return;
    setStokEkleForm(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };

  const updateItem = (index, field, value) => {
    setStokEkleForm(prev => ({
      ...prev,
      items: prev.items.map((item, i) => 
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  const selectCari = (cari) => {
    setStokEkleForm(prev => ({ ...prev, cari_hesap_id: cari.id }));
    setSelectedCariName(cari.name);
    setCariSearchInput(cari.name);
    setShowCariDropdown(false);
  };

  const selectStokKarti = (index, stok) => {
    updateItem(index, 'stok_karti_id', stok.id);
    updateItem(index, 'unit', stok.unit);
    const newDropdowns = [...showStokDropdown];
    newDropdowns[index] = false;
    setShowStokDropdown(newDropdowns);
  };

  const handleCreateStokGirisi = async () => {
    // Validations
    if (!stokEkleForm.cari_hesap_id) {
      toast.error('Cari hesap seçimi zorunludur');
      return;
    }
    if (stokEkleForm.documents.length === 0) {
      toast.error('Fatura veya irsaliye yüklemesi zorunludur');
      return;
    }
    const validItems = stokEkleForm.items.filter(item => item.stok_karti_id && item.quantity);
    if (validItems.length === 0) {
      toast.error('En az bir ürün eklemelisiniz');
      return;
    }

    try {
      await axios.post(`${API}/api/depot/stok-girisleri`, {
        ...stokEkleForm,
        items: validItems
      }, { headers: getAuthHeaders() });
      toast.success('Stok girişi oluşturuldu');
      setStokEkleModal(false);
      setStokEkleForm({
        cari_hesap_id: '',
        items: [{ stok_karti_id: '', quantity: '', unit: '' }],
        documents: [],
        description: ''
      });
      setSelectedCariName('');
      setCariSearchInput('');
      fetchStokGirisleri();
    } catch (err) {
      toast.error('Stok girişi oluşturulamadı');
    }
  };

  // Stok Girişi Silme
  const handleDeleteStokGirisi = (id) => {
    requestPasswordForAction('deleteStokGirisi', id);
  };

  const executeDeleteStokGirisi = async (id) => {
    try {
      await axios.delete(`${API}/api/depot/stok-girisleri/${id}`, { headers: getAuthHeaders() });
      toast.success('Stok girişi silindi');
      fetchStokGirisleri();
    } catch (err) {
      toast.error('Stok girişi silinemedi');
    }
  };

  // Filter functions
  const filteredCariHesaplar = cariHesaplar.filter(c => 
    c.name?.toLowerCase().includes(cariSearch.toLowerCase()) ||
    c.city?.toLowerCase().includes(cariSearch.toLowerCase())
  );

  // Gelişmiş Cari Filtreleme - Ürün, Şirket, İl, Durum bazlı
  const filteredCariProducts = allCariProducts.filter(p => {
    // Ürün filtresi
    if (cariFilters.product && p.product_name !== cariFilters.product) return false;
    // Şirket filtresi
    if (cariFilters.company && p.cari_hesap_name !== cariFilters.company) return false;
    // İl filtresi
    if (cariFilters.city && p.cari_city !== cariFilters.city) return false;
    // Durum filtresi
    if (cariFilters.status !== 'all' && p.status !== cariFilters.status) return false;
    // Arama filtresi
    if (cariSearch) {
      const searchLower = cariSearch.toLowerCase();
      return (
        p.product_name?.toLowerCase().includes(searchLower) ||
        p.cari_hesap_name?.toLowerCase().includes(searchLower) ||
        p.cari_city?.toLowerCase().includes(searchLower)
      );
    }
    return true;
  });

  // Aktif filtre sayısı
  const activeFilterCount = [
    cariFilters.product,
    cariFilters.company,
    cariFilters.city,
    cariFilters.status !== 'all' ? cariFilters.status : ''
  ].filter(Boolean).length;

  // Filtreleri temizle
  const clearCariFilters = () => {
    setCariFilters({
      product: '',
      company: '',
      city: '',
      status: 'all'
    });
    setCariSearch('');
  };

  const filteredStokKartlari = stokKartlari.filter(s => 
    s.product_name?.toLowerCase().includes(stokSearch.toLowerCase()) ||
    s.model?.toLowerCase().includes(stokSearch.toLowerCase())
  );

  useEffect(() => {
    if (cariSearchInput) {
      setFilteredCari(cariHesaplar.filter(c => 
        c.name?.toLowerCase().includes(cariSearchInput.toLowerCase())
      ));
    } else {
      setFilteredCari(cariHesaplar);
    }
  }, [cariSearchInput, cariHesaplar]);

  const getFilteredStokForItem = (searchText) => {
    if (searchText) {
      return stokKartlari.filter(s => 
        s.product_name?.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    return stokKartlari;
  };

  const birimOptions = ['adet', 'kg', 'metre', 'litre', 'paket', 'kutu', 'ton', 'metrekare', 'metre tül', 'metre küp'];

  // Excel Export Function for Cari Hesap Products
  const exportCariProductsToExcel = (cariName, products) => {
    // Helper function to calculate status
    const calculateStatus = (item, urunStatus) => {
      const expected = item.expected_quantity || item.quantity || 0;
      const received = item.received_quantity || 0;
      
      if (item.status === 'teslim_alindi' || (received > 0 && received >= expected)) {
        return 'Teslim Alındı';
      } else if (item.status === 'eksik' || (received > 0 && received < expected)) {
        return 'Eksik Teslim';
      } else if (received === 0) {
        return 'Bekliyor';
      } else {
        return item.status || urunStatus || 'Bilinmiyor';
      }
    };

    // Prepare rows for Excel
    const rows = [];
    products.forEach(urun => {
      (urun.items || []).forEach(item => {
        rows.push({
          tarih: new Date(urun.created_at).toLocaleDateString('tr-TR'),
          saat: new Date(urun.created_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }),
          urunAdi: item.product_name || '-',
          beklenen: item.expected_quantity || item.quantity || 0,
          teslimAlinan: item.received_quantity || 0,
          birim: item.unit || 'adet',
          durum: calculateStatus(item, urun.status)
        });
      });
    });

    // Build CSV content (Excel compatible with Turkish encoding)
    const BOM = '\uFEFF'; // UTF-8 BOM for Turkish characters
    const headers = ['Tarih', 'Saat', 'Ürün Adı', 'Beklenen', 'Teslim Alınan', 'Birim', 'Durum'];
    const csvContent = BOM + [
      headers.join(';'),
      ...rows.map(row => [
        row.tarih,
        row.saat,
        row.urunAdi,
        row.beklenen,
        row.teslimAlinan,
        row.birim,
        row.durum
      ].join(';'))
    ].join('\n');

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const fileName = `${cariName.replace(/[^a-zA-Z0-9ğüşıöçĞÜŞİÖÇ\s]/g, '')}_Gelen_Urunler_${new Date().toLocaleDateString('tr-TR').replace(/\./g, '-')}.csv`;
    
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    toast.success('Excel dosyası indirildi');
  };

  // Excel Export Function for Stok Girişleri
  const exportStokGirisleriToExcel = (entries) => {
    if (entries.length === 0) {
      toast.error('İndirilecek veri bulunmuyor');
      return;
    }

    // Build CSV content (Excel compatible with Turkish encoding)
    const BOM = '\uFEFF'; // UTF-8 BOM for Turkish characters
    const headers = ['Tarih', 'Saat', 'Ürün Adı', 'Miktar', 'Birim', 'Cari Hesap', 'Açıklama'];
    const csvContent = BOM + [
      headers.join(';'),
      ...entries.map(entry => [
        new Date(entry.date).toLocaleDateString('tr-TR'),
        new Date(entry.date).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }),
        entry.product_name || '-',
        entry.quantity || 0,
        entry.unit || 'adet',
        entry.cari_hesap || '-',
        (entry.description || '-').replace(/;/g, ',').replace(/\n/g, ' ')
      ].join(';'))
    ].join('\n');

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    // Generate filename with date range if filters applied
    let dateRangeStr = new Date().toLocaleDateString('tr-TR').replace(/\./g, '-');
    if (stokGirisiDateFilter.startDate && stokGirisiDateFilter.endDate) {
      dateRangeStr = `${stokGirisiDateFilter.startDate}_${stokGirisiDateFilter.endDate}`;
    } else if (stokGirisiDateFilter.startDate) {
      dateRangeStr = `${stokGirisiDateFilter.startDate}_sonrasi`;
    } else if (stokGirisiDateFilter.endDate) {
      dateRangeStr = `${stokGirisiDateFilter.endDate}_oncesi`;
    }
    
    const fileName = `Stok_Girisleri_${dateRangeStr}.csv`;
    
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    toast.success('Excel dosyası indirildi');
  };

  // Clear date filters
  const clearDateFilters = () => {
    setStokGirisiDateFilter({ startDate: '', endDate: '' });
  };

  // Bilgilendirme kutusunu kapat ve localStorage'a kaydet
  const hideCariInfo = () => {
    setShowCariInfo(false);
    localStorage.setItem('depot_cari_info_hidden', 'true');
  };

  const hideStokGirisiInfo = () => {
    setShowStokGirisiInfo(false);
    localStorage.setItem('depot_stok_girisi_info_hidden', 'true');
  };

  return (
    <div className="space-y-6" data-testid="depot-entry">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Depo Giriş</h1>
          <p className="text-gray-500">Cari hesap, stok kartı ve stok girişi yönetimi</p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="cari" className="gap-2">
            <Building2 className="h-4 w-4" />
            CARİ HESAP
          </TabsTrigger>
          <TabsTrigger value="stok-ekle" className="gap-2">
            <PackagePlus className="h-4 w-4" />
            STOK GİRİŞLERİ
          </TabsTrigger>
        </TabsList>

        {/* CARİ HESAP TAB */}
        <TabsContent value="cari" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Cari Hesaplar</CardTitle>
            </CardHeader>
            <CardContent>
              {/* Kapanabilir Bilgilendirme Kutusu */}
              {showCariInfo && (
                <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg relative">
                  <button 
                    onClick={hideCariInfo}
                    className="absolute top-2 right-2 p-1 hover:bg-blue-100 rounded-full transition-colors"
                    aria-label="Bilgilendirmeyi kapat"
                  >
                    <X className="h-4 w-4 text-blue-600" />
                  </button>
                  <div className="flex gap-3 pr-6">
                    <Info className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                    <p className="text-sm text-blue-800">
                      Cari Hesap bölümünde ürün tedariği için çalışılan firmaların listesi bulunmaktadır. 
                      Bu listedeki firmaların isimlerine tıklayınca firmalarla yapılan ürün tedariklerinin içeriğine erişebilirsiniz. 
                      Kontrollerinizi buradan kolayca sağlayabilirsiniz.
                    </p>
                  </div>
                </div>
              )}
              
              {/* Arama ve Filtre Paneli */}
              <div className="mb-4 space-y-3">
                <div className="flex flex-wrap items-center gap-3">
                  {/* Arama */}
                  <div className="relative flex-1 min-w-[200px]">
                    <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                    <Input
                      placeholder="Ürün, şirket veya il ara..."
                      value={cariSearch}
                      onChange={(e) => setCariSearch(e.target.value)}
                      className="pl-10"
                    />
                  </div>
                  
                  {/* Filtre Butonu */}
                  <Button 
                    variant={showCariFilters ? "default" : "outline"}
                    onClick={() => setShowCariFilters(!showCariFilters)}
                    className="gap-2"
                  >
                    <Filter className="h-4 w-4" />
                    Filtreler
                    {activeFilterCount > 0 && (
                      <Badge className="ml-1 bg-white text-emerald-700">{activeFilterCount}</Badge>
                    )}
                  </Button>
                  
                  {/* Filtreleri Temizle */}
                  {activeFilterCount > 0 && (
                    <Button 
                      variant="ghost" 
                      size="sm"
                      onClick={clearCariFilters}
                      className="text-red-600 hover:text-red-700 hover:bg-red-50"
                    >
                      <X className="h-4 w-4 mr-1" />
                      Temizle
                    </Button>
                  )}
                </div>
                
                {/* Filtre Dropdown'ları */}
                {showCariFilters && (
                  <div className="p-4 bg-gray-50 border rounded-lg">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                      {/* Ürün Filtresi */}
                      <div>
                        <Label className="text-sm font-medium text-gray-700 mb-1 block">Ürün</Label>
                        <select 
                          value={cariFilters.product}
                          onChange={(e) => setCariFilters(prev => ({ ...prev, product: e.target.value }))}
                          className="w-full h-10 px-3 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                        >
                          <option value="">Tüm Ürünler</option>
                          {cariFilterOptions.product_names?.map((name) => (
                            <option key={name} value={name}>{name}</option>
                          ))}
                        </select>
                      </div>
                      
                      {/* Şirket Filtresi */}
                      <div>
                        <Label className="text-sm font-medium text-gray-700 mb-1 block">Şirket (Cari Hesap)</Label>
                        <select 
                          value={cariFilters.company}
                          onChange={(e) => setCariFilters(prev => ({ ...prev, company: e.target.value }))}
                          className="w-full h-10 px-3 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                        >
                          <option value="">Tüm Şirketler</option>
                          {cariFilterOptions.cari_names?.map((name) => (
                            <option key={name} value={name}>{name}</option>
                          ))}
                        </select>
                      </div>
                      
                      {/* İl Filtresi */}
                      <div>
                        <Label className="text-sm font-medium text-gray-700 mb-1 block">İl</Label>
                        <select 
                          value={cariFilters.city}
                          onChange={(e) => setCariFilters(prev => ({ ...prev, city: e.target.value }))}
                          className="w-full h-10 px-3 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                        >
                          <option value="">Tüm İller</option>
                          {cariFilterOptions.cities?.map((city) => (
                            <option key={city} value={city}>{city}</option>
                          ))}
                        </select>
                      </div>
                      
                      {/* Durum Filtresi */}
                      <div>
                        <Label className="text-sm font-medium text-gray-700 mb-1 block">Durum</Label>
                        <select 
                          value={cariFilters.status}
                          onChange={(e) => setCariFilters(prev => ({ ...prev, status: e.target.value }))}
                          className="w-full h-10 px-3 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                        >
                          <option value="all">Tüm Durumlar</option>
                          <option value="bekliyor">Bekliyor</option>
                          <option value="eksik">Eksik Teslim</option>
                          <option value="teslim_alindi">Teslim Alındı</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Filtrelenmiş Ürünler Tablosu - Aktif filtre varsa göster */}
              {(activeFilterCount > 0 || cariSearch) && (
                <div className="mb-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="font-semibold text-gray-800 flex items-center gap-2">
                      <Package className="h-5 w-5 text-emerald-600" />
                      Filtrelenmiş Ürünler 
                      <Badge variant="outline" className="ml-2">{filteredCariProducts.length} kayıt</Badge>
                    </h3>
                  </div>
                  
                  {cariProductsLoading ? (
                    <div className="text-center py-8 text-gray-500">Yükleniyor...</div>
                  ) : filteredCariProducts.length === 0 ? (
                    <div className="text-center py-8 text-gray-500 bg-gray-50 rounded-lg border">
                      Filtre kriterlerine uygun ürün bulunamadı
                    </div>
                  ) : (
                    <div className="border rounded-lg overflow-hidden">
                      <Table>
                        <TableHeader>
                          <TableRow className="bg-emerald-50">
                            <TableHead>Tarih</TableHead>
                            <TableHead>Ürün Adı</TableHead>
                            <TableHead>Şirket</TableHead>
                            <TableHead>İl</TableHead>
                            <TableHead className="text-right">Beklenen</TableHead>
                            <TableHead className="text-right">Teslim Alınan</TableHead>
                            <TableHead>Birim</TableHead>
                            <TableHead>Durum</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {filteredCariProducts.slice(0, 100).map((product) => (
                            <TableRow key={product.id} className="hover:bg-gray-50">
                              <TableCell className="text-sm">
                                {product.created_at ? new Date(product.created_at).toLocaleDateString('tr-TR') : '-'}
                              </TableCell>
                              <TableCell className="font-medium">{product.product_name}</TableCell>
                              <TableCell>
                                <div className="flex items-center gap-2">
                                  <Building2 className="h-4 w-4 text-gray-400" />
                                  {product.cari_hesap_name}
                                </div>
                              </TableCell>
                              <TableCell>{product.cari_city || '-'}</TableCell>
                              <TableCell className="text-right font-mono">{product.expected_quantity}</TableCell>
                              <TableCell className="text-right font-mono">
                                <span className={product.received_quantity < product.expected_quantity ? 'text-red-600' : 'text-green-600'}>
                                  {product.received_quantity}
                                </span>
                              </TableCell>
                              <TableCell>{product.unit}</TableCell>
                              <TableCell>
                                {product.status === 'teslim_alindi' ? (
                                  <Badge className="bg-green-100 text-green-800">Teslim Alındı</Badge>
                                ) : product.status === 'eksik' ? (
                                  <Badge className="bg-yellow-100 text-yellow-800">Eksik Teslim</Badge>
                                ) : (
                                  <Badge className="bg-blue-100 text-blue-800">Bekliyor</Badge>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {filteredCariProducts.length > 100 && (
                        <div className="p-3 bg-gray-50 text-center text-sm text-gray-500">
                          {filteredCariProducts.length} kayıttan ilk 100 tanesi gösteriliyor
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Cari Hesaplar Tablosu */}
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Oluşturulma Tarihi</TableHead>
                    <TableHead>Cari Hesap Adı</TableHead>
                    <TableHead>İl</TableHead>
                    <TableHead>Telefon</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {filteredCariHesaplar.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} className="text-center text-gray-500 py-8">
                        Henüz cari hesap bulunmuyor
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredCariHesaplar.map((cari) => (
                      <React.Fragment key={cari.id}>
                        <TableRow 
                          className={`cursor-pointer hover:bg-gray-50 ${selectedCariDetail === cari.id ? 'bg-emerald-50' : ''}`}
                          onClick={() => fetchCariGelecekUrunler(cari.id, cari.name)}
                        >
                          <TableCell>{new Date(cari.created_at).toLocaleDateString('tr-TR')}</TableCell>
                          <TableCell className="font-medium">
                            <div className="flex items-center gap-2">
                              <Building2 className={`h-4 w-4 ${selectedCariDetail === cari.id ? 'text-emerald-600' : 'text-gray-400'}`} />
                              {cari.name}
                              {selectedCariDetail === cari.id && (
                                <Badge variant="outline" className="text-emerald-600 border-emerald-300">Açık</Badge>
                              )}
                            </div>
                          </TableCell>
                          <TableCell>{cari.city || '-'}</TableCell>
                          <TableCell>{cari.phone || '-'}</TableCell>
                        </TableRow>
                        {/* Cari Hesap Detay - Gelecek Ürünler */}
                        {selectedCariDetail === cari.id && (
                          <TableRow>
                            <TableCell colSpan={4} className="bg-gray-50 p-0">
                              <div className="p-4 border-t border-b border-emerald-200">
                                <div className="flex items-center justify-between mb-3">
                                  <div className="flex items-center gap-2">
                                    <Package className="h-5 w-5 text-emerald-600" />
                                    <h4 className="font-semibold text-emerald-800">
                                      {cari.name} - Gelen Ürünler
                                    </h4>
                                  </div>
                                  {cariGelecekUrunler.length > 0 && (
                                    <Button 
                                      variant="outline" 
                                      size="sm" 
                                      onClick={() => exportCariProductsToExcel(cari.name, cariGelecekUrunler)}
                                      className="gap-1 text-emerald-700 border-emerald-300 hover:bg-emerald-50"
                                    >
                                      <Download className="h-4 w-4" />
                                      Excel İndir
                                    </Button>
                                  )}
                                </div>
                                {cariDetailLoading ? (
                                  <div className="text-center py-4 text-gray-500">Yükleniyor...</div>
                                ) : cariGelecekUrunler.length === 0 ? (
                                  <div className="text-center py-4 text-gray-500">
                                    Bu cari hesaptan gelen ürün bulunmuyor
                                  </div>
                                ) : (
                                  <div className="overflow-x-auto">
                                    <Table>
                                      <TableHeader>
                                        <TableRow className="bg-emerald-100/50">
                                          <TableHead>Tarih</TableHead>
                                          <TableHead>Ürün Adı</TableHead>
                                          <TableHead className="text-right">Beklenen</TableHead>
                                          <TableHead className="text-right">Teslim Alınan</TableHead>
                                          <TableHead>Birim</TableHead>
                                          <TableHead>Durum</TableHead>
                                        </TableRow>
                                      </TableHeader>
                                      <TableBody>
                                        {cariGelecekUrunler.flatMap((urun) => 
                                          (urun.items || []).map((item, idx) => (
                                            <TableRow key={`${urun.id}-${idx}`} className="hover:bg-emerald-50/50">
                                              <TableCell className="text-sm">
                                                <div>{new Date(urun.created_at).toLocaleDateString('tr-TR')}</div>
                                                <div className="text-xs text-gray-500">
                                                  {new Date(urun.created_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                                                </div>
                                              </TableCell>
                                              <TableCell className="font-medium">{item.product_name || '-'}</TableCell>
                                              <TableCell className="text-right font-mono">
                                                {item.expected_quantity || item.quantity || 0}
                                              </TableCell>
                                              <TableCell className="text-right font-mono">
                                                <span className={
                                                  (item.received_quantity || 0) < (item.expected_quantity || item.quantity || 0)
                                                    ? 'text-red-600'
                                                    : 'text-green-600'
                                                }>
                                                  {item.received_quantity || 0}
                                                </span>
                                              </TableCell>
                                              <TableCell>{item.unit || 'adet'}</TableCell>
                                              <TableCell>
                                                {(() => {
                                                  // Item bazlı durum hesaplama
                                                  const expected = item.expected_quantity || item.quantity || 0;
                                                  const received = item.received_quantity || 0;
                                                  
                                                  // Önce item'ın kendi status'unu kontrol et
                                                  if (item.status === 'teslim_alindi' || (received > 0 && received >= expected)) {
                                                    return <Badge className="bg-green-100 text-green-800">Teslim Alındı</Badge>;
                                                  } else if (item.status === 'eksik' || (received > 0 && received < expected)) {
                                                    return <Badge className="bg-yellow-100 text-yellow-800">Eksik Teslim</Badge>;
                                                  } else if (received === 0 && urun.status === 'bekliyor') {
                                                    return <Badge className="bg-blue-100 text-blue-800">Bekliyor</Badge>;
                                                  } else if (received === 0) {
                                                    return <Badge className="bg-blue-100 text-blue-800">Bekliyor</Badge>;
                                                  } else {
                                                    return <Badge className="bg-gray-100 text-gray-800">{item.status || urun.status}</Badge>;
                                                  }
                                                })()}
                                              </TableCell>
                                            </TableRow>
                                          ))
                                        )}
                                      </TableBody>
                                    </Table>
                                  </div>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    ))
                  )}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </TabsContent>

        {/* STOK GİRİŞLERİ TAB */}
        <TabsContent value="stok-ekle" className="space-y-4">
          <Card>
            <CardHeader className="flex flex-col gap-4">
              <div className="flex flex-row items-center justify-between">
                <CardTitle>Stok Girişleri</CardTitle>
                <div className="flex items-center gap-3">
                  {/* Search Input */}
                  <div className="relative">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                    <Input
                      placeholder="Cari hesap veya ürün ara..."
                      value={stokGirisiSearch}
                      onChange={(e) => setStokGirisiSearch(e.target.value)}
                      className="pl-10 w-64"
                    />
                  </div>
                </div>
              </div>
              
              {/* Kapanabilir Bilgilendirme Kutusu */}
              {showStokGirisiInfo && (
                <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg relative">
                  <button 
                    onClick={hideStokGirisiInfo}
                    className="absolute top-2 right-2 p-1 hover:bg-blue-100 rounded-full transition-colors"
                    aria-label="Bilgilendirmeyi kapat"
                  >
                    <X className="h-4 w-4 text-blue-600" />
                  </button>
                  <div className="flex gap-3 pr-6">
                    <Info className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                    <p className="text-sm text-blue-800">
                      Stok Girişleri bölümünde depo stoğunuza gelen ürünlerin listesine ulaşabilirsiniz. 
                      Kontrollerinizi buradan kolayca sağlayabilirsiniz.
                    </p>
                  </div>
                </div>
              )}
              
              {/* Date Filters and Excel Export Row */}
              <div className="flex flex-wrap items-center justify-between gap-3 pt-2 border-t">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4 text-gray-500" />
                    <span className="text-sm text-gray-600">Tarih Filtresi:</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Input
                      type="date"
                      value={stokGirisiDateFilter.startDate}
                      onChange={(e) => setStokGirisiDateFilter(prev => ({ ...prev, startDate: e.target.value }))}
                      className="w-40"
                      placeholder="Başlangıç"
                    />
                    <span className="text-gray-400">-</span>
                    <Input
                      type="date"
                      value={stokGirisiDateFilter.endDate}
                      onChange={(e) => setStokGirisiDateFilter(prev => ({ ...prev, endDate: e.target.value }))}
                      className="w-40"
                      placeholder="Bitiş"
                    />
                    {(stokGirisiDateFilter.startDate || stokGirisiDateFilter.endDate) && (
                      <Button 
                        variant="ghost" 
                        size="sm" 
                        onClick={clearDateFilters}
                        className="text-gray-500 hover:text-gray-700"
                      >
                        <X className="h-4 w-4" />
                        Temizle
                      </Button>
                    )}
                  </div>
                </div>
                
                {/* Excel Export Button */}
                <Button 
                  variant="outline" 
                  size="sm" 
                  onClick={() => {
                    // Get filtered entries to export
                    const allEntries = [];
                    stokGirisleri.forEach(giris => {
                      giris.items?.forEach(item => {
                        allEntries.push({
                          date: giris.created_at,
                          product_name: item.product_name,
                          quantity: item.quantity,
                          unit: item.unit,
                          cari_hesap: giris.cari_hesap_name,
                          description: giris.description
                        });
                      });
                    });
                    
                    // Apply date filter
                    const filtered = allEntries.filter(entry => {
                      const entryDate = new Date(entry.date);
                      if (stokGirisiDateFilter.startDate) {
                        const startDate = new Date(stokGirisiDateFilter.startDate);
                        startDate.setHours(0, 0, 0, 0);
                        if (entryDate < startDate) return false;
                      }
                      if (stokGirisiDateFilter.endDate) {
                        const endDate = new Date(stokGirisiDateFilter.endDate);
                        endDate.setHours(23, 59, 59, 999);
                        if (entryDate > endDate) return false;
                      }
                      // Apply search filter too
                      if (stokGirisiSearch.trim()) {
                        return entry.product_name?.toLowerCase().includes(stokGirisiSearch.toLowerCase()) ||
                               entry.cari_hesap?.toLowerCase().includes(stokGirisiSearch.toLowerCase());
                      }
                      return true;
                    });
                    
                    exportStokGirisleriToExcel(filtered);
                  }}
                  className="gap-1 text-emerald-700 border-emerald-300 hover:bg-emerald-50"
                >
                  <Download className="h-4 w-4" />
                  Excel İndir
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead 
                      className="cursor-pointer hover:bg-gray-100 select-none"
                      onClick={() => setStokGirisiSort(prev => ({
                        column: 'date',
                        direction: prev.column === 'date' && prev.direction === 'desc' ? 'asc' : 'desc'
                      }))}
                    >
                      <div className="flex items-center gap-1">
                        Tarih
                        {stokGirisiSort.column === 'date' ? (
                          stokGirisiSort.direction === 'desc' ? <ArrowDown className="h-4 w-4" /> : <ArrowUp className="h-4 w-4" />
                        ) : <ArrowUpDown className="h-4 w-4 text-gray-400" />}
                      </div>
                    </TableHead>
                    <TableHead 
                      className="cursor-pointer hover:bg-gray-100 select-none"
                      onClick={() => setStokGirisiSort(prev => ({
                        column: 'product_name',
                        direction: prev.column === 'product_name' && prev.direction === 'asc' ? 'desc' : 'asc'
                      }))}
                    >
                      <div className="flex items-center gap-1">
                        Ürün Adı
                        {stokGirisiSort.column === 'product_name' ? (
                          stokGirisiSort.direction === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />
                        ) : <ArrowUpDown className="h-4 w-4 text-gray-400" />}
                      </div>
                    </TableHead>
                    <TableHead 
                      className="text-right cursor-pointer hover:bg-gray-100 select-none"
                      onClick={() => setStokGirisiSort(prev => ({
                        column: 'quantity',
                        direction: prev.column === 'quantity' && prev.direction === 'desc' ? 'asc' : 'desc'
                      }))}
                    >
                      <div className="flex items-center justify-end gap-1">
                        Miktar
                        {stokGirisiSort.column === 'quantity' ? (
                          stokGirisiSort.direction === 'desc' ? <ArrowDown className="h-4 w-4" /> : <ArrowUp className="h-4 w-4" />
                        ) : <ArrowUpDown className="h-4 w-4 text-gray-400" />}
                      </div>
                    </TableHead>
                    <TableHead 
                      className="cursor-pointer hover:bg-gray-100 select-none"
                      onClick={() => setStokGirisiSort(prev => ({
                        column: 'unit',
                        direction: prev.column === 'unit' && prev.direction === 'asc' ? 'desc' : 'asc'
                      }))}
                    >
                      <div className="flex items-center gap-1">
                        Birim
                        {stokGirisiSort.column === 'unit' ? (
                          stokGirisiSort.direction === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />
                        ) : <ArrowUpDown className="h-4 w-4 text-gray-400" />}
                      </div>
                    </TableHead>
                    <TableHead 
                      className="cursor-pointer hover:bg-gray-100 select-none"
                      onClick={() => setStokGirisiSort(prev => ({
                        column: 'cari_hesap',
                        direction: prev.column === 'cari_hesap' && prev.direction === 'asc' ? 'desc' : 'asc'
                      }))}
                    >
                      <div className="flex items-center gap-1">
                        Cari Hesap
                        {stokGirisiSort.column === 'cari_hesap' ? (
                          stokGirisiSort.direction === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />
                        ) : <ArrowUpDown className="h-4 w-4 text-gray-400" />}
                      </div>
                    </TableHead>
                    <TableHead>Tip</TableHead>
                    <TableHead>Belgeler</TableHead>
                    <TableHead>Açıklama</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {(() => {
                    // Her stok girişini ayrı satır olarak listele
                    const allEntries = [];
                    stokGirisleri.forEach(giris => {
                      giris.items?.forEach(item => {
                        allEntries.push({
                          date: giris.created_at,
                          product_name: item.product_name,
                          quantity: item.quantity,
                          unit: item.unit,
                          cari_hesap: giris.cari_hesap_name,
                          description: giris.description,
                          entry_type: giris.entry_type,
                          transfer_teslim_alan_belgesi: giris.transfer_teslim_alan_belgesi,
                          transfer_teslim_eden_belgesi: giris.transfer_teslim_eden_belgesi
                        });
                      });
                    });

                    // Sıralama uygula
                    allEntries.sort((a, b) => {
                      const { column, direction } = stokGirisiSort;
                      let comparison = 0;
                      
                      if (column === 'date') {
                        comparison = new Date(a.date) - new Date(b.date);
                      } else if (column === 'quantity') {
                        comparison = (a.quantity || 0) - (b.quantity || 0);
                      } else if (column === 'product_name' || column === 'unit' || column === 'cari_hesap') {
                        const aVal = (a[column] || '').toLowerCase();
                        const bVal = (b[column] || '').toLowerCase();
                        comparison = aVal.localeCompare(bVal, 'tr');
                      }
                      
                      return direction === 'asc' ? comparison : -comparison;
                    });
                    
                    // Arama ve tarih filtresi uygula
                    const filteredEntries = allEntries.filter(entry => {
                      // Tarih filtresi
                      const entryDate = new Date(entry.date);
                      if (stokGirisiDateFilter.startDate) {
                        const startDate = new Date(stokGirisiDateFilter.startDate);
                        startDate.setHours(0, 0, 0, 0);
                        if (entryDate < startDate) return false;
                      }
                      if (stokGirisiDateFilter.endDate) {
                        const endDate = new Date(stokGirisiDateFilter.endDate);
                        endDate.setHours(23, 59, 59, 999);
                        if (entryDate > endDate) return false;
                      }
                      
                      // Arama filtresi
                      if (stokGirisiSearch.trim()) {
                        return entry.product_name?.toLowerCase().includes(stokGirisiSearch.toLowerCase()) ||
                               entry.cari_hesap?.toLowerCase().includes(stokGirisiSearch.toLowerCase());
                      }
                      return true;
                    });

                    if (filteredEntries.length === 0) {
                      return (
                        <TableRow>
                          <TableCell colSpan={8} className="text-center text-gray-500 py-8">
                            {stokGirisiSearch || stokGirisiDateFilter.startDate || stokGirisiDateFilter.endDate 
                              ? 'Filtre sonucu bulunamadı' 
                              : 'Henüz stok girişi bulunmuyor'}
                          </TableCell>
                        </TableRow>
                      );
                    }

                    return filteredEntries.map((entry, idx) => (
                      <TableRow key={idx} className="hover:bg-gray-50">
                        <TableCell className="text-sm">
                          {new Date(entry.date).toLocaleDateString('tr-TR')}
                          <span className="text-gray-400 ml-1">
                            {new Date(entry.date).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                          </span>
                        </TableCell>
                        <TableCell className="font-medium">
                          <div className="flex items-center gap-2">
                            <Package className="h-4 w-4 text-emerald-500" />
                            {entry.product_name}
                          </div>
                        </TableCell>
                        <TableCell className="text-right font-mono text-lg text-emerald-600">
                          +{entry.quantity}
                        </TableCell>
                        <TableCell>{entry.unit}</TableCell>
                        <TableCell>
                          <span className="text-gray-700">{entry.cari_hesap || '-'}</span>
                        </TableCell>
                        <TableCell>
                          {entry.entry_type === 'transfer' ? (
                            <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-100">
                              <ArrowUpDown className="h-3 w-3 mr-1" />
                              Transfer
                            </Badge>
                          ) : (
                            <Badge variant="outline" className="text-gray-500">
                              Normal
                            </Badge>
                          )}
                        </TableCell>
                        <TableCell>
                          {entry.entry_type === 'transfer' && (entry.transfer_teslim_alan_belgesi || entry.transfer_teslim_eden_belgesi) ? (
                            <div className="space-y-1">
                              {entry.transfer_teslim_alan_belgesi && (
                                <a
                                  href={`${API}${entry.transfer_teslim_alan_belgesi.url}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800 hover:underline bg-blue-50 px-2 py-1 rounded"
                                >
                                  <Download className="h-3 w-3" />
                                  Teslim Alan
                                </a>
                              )}
                              {entry.transfer_teslim_eden_belgesi && (
                                <a
                                  href={`${API}${entry.transfer_teslim_eden_belgesi.url}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex items-center gap-1 text-xs text-green-600 hover:text-green-800 hover:underline bg-green-50 px-2 py-1 rounded"
                                >
                                  <Download className="h-3 w-3" />
                                  Teslim Eden
                                </a>
                              )}
                            </div>
                          ) : (
                            <span className="text-gray-400 text-sm">-</span>
                          )}
                        </TableCell>
                        <TableCell className="text-sm text-gray-500 max-w-[200px] truncate">
                          {entry.description || '-'}
                        </TableCell>
                      </TableRow>
                    ));
                  })()}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {/* Cari Hesap Modal */}
      <Dialog open={cariModal} onOpenChange={setCariModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Yeni Cari Hesap</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Cari Hesap Adı *</Label>
              <Input
                value={cariForm.name}
                onChange={(e) => setCariForm({ ...cariForm, name: e.target.value })}
                placeholder="Firma adı"
              />
            </div>
            <div>
              <Label>İl</Label>
              <Input
                value={cariForm.city}
                onChange={(e) => setCariForm({ ...cariForm, city: e.target.value })}
                placeholder="İstanbul"
              />
            </div>
            <div>
              <Label>Telefon Numarası</Label>
              <Input
                value={cariForm.phone}
                onChange={(e) => setCariForm({ ...cariForm, phone: e.target.value })}
                placeholder="0212 XXX XX XX"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setCariModal(false)}>İptal</Button>
            <Button onClick={handleCreateCari} className="bg-emerald-600 hover:bg-emerald-700">Kaydet</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Stok Kartı Modal */}
      <Dialog open={stokModal} onOpenChange={setStokModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Yeni Stok Kartı</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Ürün Adı *</Label>
              <Input
                value={stokForm.product_name}
                onChange={(e) => setStokForm({ ...stokForm, product_name: e.target.value })}
                placeholder="Ürün adı"
              />
            </div>
            <div>
              <Label>Model</Label>
              <Input
                value={stokForm.model}
                onChange={(e) => setStokForm({ ...stokForm, model: e.target.value })}
                placeholder="Model numarası"
              />
            </div>
            <div>
              <Label>Özellikler</Label>
              <Textarea
                value={stokForm.features}
                onChange={(e) => setStokForm({ ...stokForm, features: e.target.value })}
                placeholder="Ürün özellikleri"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Birim *</Label>
                <select
                  value={stokForm.unit}
                  onChange={(e) => setStokForm({ ...stokForm, unit: e.target.value })}
                  className="w-full rounded-md border border-gray-300 p-2"
                >
                  {birimOptions.map(b => (
                    <option key={b} value={b}>{b}</option>
                  ))}
                </select>
              </div>
              <div>
                <Label>Minimum Stok</Label>
                <Input
                  type="number"
                  value={stokForm.minimum_stock}
                  onChange={(e) => setStokForm({ ...stokForm, minimum_stock: e.target.value })}
                  placeholder="0"
                />
              </div>
              <div>
                <Label>Max Kullanım (Proje)</Label>
                <Input
                  type="number"
                  value={stokForm.max_usage}
                  onChange={(e) => setStokForm({ ...stokForm, max_usage: e.target.value })}
                  placeholder="Örn: 100"
                />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setStokModal(false)}>İptal</Button>
            <Button onClick={handleCreateStokKarti} className="bg-emerald-600 hover:bg-emerald-700">Kaydet</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Stok Ekle Modal */}
      <Dialog open={stokEkleModal} onOpenChange={setStokEkleModal}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Stok Ekle</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            {/* Tarih - Otomatik */}
            <div>
              <Label>Oluşturulma Tarihi</Label>
              <Input
                value={new Date().toLocaleDateString('tr-TR')}
                disabled
                className="bg-gray-50"
              />
            </div>

            {/* Cari Hesap Seçimi */}
            <div className="relative">
              <Label>Cari Hesap *</Label>
              <Input
                value={cariSearchInput}
                onChange={(e) => {
                  setCariSearchInput(e.target.value);
                  setShowCariDropdown(true);
                  if (!e.target.value) {
                    setStokEkleForm(prev => ({ ...prev, cari_hesap_id: '' }));
                    setSelectedCariName('');
                  }
                }}
                onFocus={() => setShowCariDropdown(true)}
                placeholder="Cari hesap ara..."
              />
              {showCariDropdown && filteredCari.length > 0 && (
                <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-48 overflow-y-auto">
                  {filteredCari.map(cari => (
                    <div
                      key={cari.id}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => selectCari(cari)}
                    >
                      <p className="font-medium">{cari.name}</p>
                      <p className="text-sm text-gray-500">{cari.city}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Ürünler */}
            <div>
              <div className="flex items-center justify-between mb-2">
                <Label>Ürünler *</Label>
                <Button type="button" variant="outline" size="sm" onClick={addNewItem} className="gap-1">
                  <Plus className="h-4 w-4" />
                  Yeni Ürün Ekle
                </Button>
              </div>
              <div className="space-y-3">
                {stokEkleForm.items.map((item, index) => (
                  <div key={index} className="flex gap-2 items-start p-3 border rounded-lg bg-gray-50">
                    <div className="flex-1 relative">
                      <Label className="text-xs">Stok Kartı</Label>
                      <Input
                        placeholder="Ürün ara..."
                        onChange={(e) => {
                          const newDropdowns = [...showStokDropdown];
                          newDropdowns[index] = true;
                          setShowStokDropdown(newDropdowns);
                        }}
                        onFocus={() => {
                          const newDropdowns = [...showStokDropdown];
                          newDropdowns[index] = true;
                          setShowStokDropdown(newDropdowns);
                        }}
                        value={stokKartlari.find(s => s.id === item.stok_karti_id)?.product_name || ''}
                        readOnly
                      />
                      {showStokDropdown[index] && (
                        <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-48 overflow-y-auto">
                          {stokKartlari.map(stok => (
                            <div
                              key={stok.id}
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                              onClick={() => selectStokKarti(index, stok)}
                            >
                              <p className="font-medium">{stok.product_name}</p>
                              <p className="text-sm text-gray-500">{stok.model} - {stok.unit}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="w-24">
                      <Label className="text-xs">Miktar</Label>
                      <Input
                        type="number"
                        value={item.quantity}
                        onChange={(e) => updateItem(index, 'quantity', e.target.value)}
                        placeholder="0"
                      />
                    </div>
                    <div className="w-20">
                      <Label className="text-xs">Birim</Label>
                      <Input
                        value={item.unit || '-'}
                        disabled
                        className="bg-gray-100"
                      />
                    </div>
                    {stokEkleForm.items.length > 1 && (
                      <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        onClick={() => removeItem(index)}
                        className="mt-6 text-red-600"
                      >
                        <X className="h-4 w-4" />
                      </Button>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Belge Yükleme - ZORUNLU */}
            <div>
              <Label className="flex items-center gap-2">
                <FileText className="h-4 w-4" />
                Fatura / İrsaliye * <span className="text-red-500 text-xs">(Zorunlu)</span>
              </Label>
              <div className="mt-2">
                <label className="flex items-center justify-center w-full h-24 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-emerald-500 hover:bg-emerald-50 transition-colors">
                  <div className="text-center">
                    <Upload className="mx-auto h-8 w-8 text-gray-400" />
                    <span className="text-sm text-gray-500">Belge yüklemek için tıklayın</span>
                  </div>
                  <input
                    type="file"
                    multiple
                    accept="image/*,.pdf"
                    onChange={handleFileUpload}
                    className="hidden"
                  />
                </label>
              </div>
              {stokEkleForm.documents.length > 0 && (
                <div className="mt-2 space-y-2">
                  {stokEkleForm.documents.map((doc, idx) => (
                    <div key={idx} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                      <span className="text-sm truncate">{doc.name}</span>
                      <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        onClick={() => removeDocument(idx)}
                        className="text-red-600"
                      >
                        <X className="h-4 w-4" />
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Açıklama */}
            <div>
              <Label>Açıklama (Opsiyonel)</Label>
              <Textarea
                value={stokEkleForm.description}
                onChange={(e) => setStokEkleForm({ ...stokEkleForm, description: e.target.value })}
                placeholder="Ek notlar..."
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setStokEkleModal(false)}>İptal</Button>
            <Button onClick={handleCreateStokGirisi} className="bg-emerald-600 hover:bg-emerald-700">
              <Check className="h-4 w-4 mr-2" />
              Stoğa Ekle
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Edit Cari Hesap Modal */}
      <Dialog open={editCariModal} onOpenChange={setEditCariModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Cari Hesap Düzenle</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Cari Hesap Adı *</Label>
              <Input
                value={editCariForm.name}
                onChange={(e) => setEditCariForm({ ...editCariForm, name: e.target.value })}
                placeholder="Firma adı"
              />
            </div>
            <div>
              <Label>İl</Label>
              <Input
                value={editCariForm.city}
                onChange={(e) => setEditCariForm({ ...editCariForm, city: e.target.value })}
                placeholder="İstanbul"
              />
            </div>
            <div>
              <Label>Telefon Numarası</Label>
              <Input
                value={editCariForm.phone}
                onChange={(e) => setEditCariForm({ ...editCariForm, phone: e.target.value })}
                placeholder="0212 XXX XX XX"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setEditCariModal(false)}>İptal</Button>
            <Button onClick={handleUpdateCari} className="bg-emerald-600 hover:bg-emerald-700">Güncelle</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Edit Stok Kartı Modal */}
      <Dialog open={editStokModal} onOpenChange={setEditStokModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Stok Kartı Düzenle</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Ürün Adı *</Label>
              <Input
                value={editStokForm.product_name}
                onChange={(e) => setEditStokForm({ ...editStokForm, product_name: e.target.value })}
                placeholder="Ürün adı"
              />
            </div>
            <div>
              <Label>Model</Label>
              <Input
                value={editStokForm.model}
                onChange={(e) => setEditStokForm({ ...editStokForm, model: e.target.value })}
                placeholder="Model numarası"
              />
            </div>
            <div>
              <Label>Özellikler</Label>
              <Textarea
                value={editStokForm.features}
                onChange={(e) => setEditStokForm({ ...editStokForm, features: e.target.value })}
                placeholder="Ürün özellikleri"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Birim *</Label>
                <select
                  value={editStokForm.unit}
                  onChange={(e) => setEditStokForm({ ...editStokForm, unit: e.target.value })}
                  className="w-full rounded-md border border-gray-300 p-2"
                >
                  {birimOptions.map(b => (
                    <option key={b} value={b}>{b}</option>
                  ))}
                </select>
              </div>
              <div>
                <Label>Minimum Stok</Label>
                <Input
                  type="number"
                  value={editStokForm.minimum_stock}
                  onChange={(e) => setEditStokForm({ ...editStokForm, minimum_stock: e.target.value })}
                  placeholder="0"
                />
              </div>
              <div>
                <Label>Max Kullanım (Proje)</Label>
                <Input
                  type="number"
                  value={editStokForm.max_usage}
                  onChange={(e) => setEditStokForm({ ...editStokForm, max_usage: e.target.value })}
                  placeholder="Örn: 100"
                />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setEditStokModal(false)}>İptal</Button>
            <Button onClick={handleUpdateStokKarti} className="bg-emerald-600 hover:bg-emerald-700">Güncelle</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Stok Girişi Detay Modal */}
      <Dialog open={detailModal} onOpenChange={setDetailModal}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Stok Girişi Detayı</DialogTitle>
          </DialogHeader>
          {detailData && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-gray-500">Tarih</Label>
                  <p className="font-medium">{new Date(detailData.created_at).toLocaleString('tr-TR')}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Cari Hesap</Label>
                  <p className="font-medium">{detailData.cari_hesap_name}</p>
                </div>
                <div>
                  <Label className="text-gray-500">Oluşturan</Label>
                  <p className="font-medium">{detailData.created_by_name || '-'}</p>
                </div>
              </div>
              
              <div>
                <Label className="text-gray-500">Ürünler</Label>
                <div className="mt-2 border rounded-lg divide-y">
                  {detailData.items?.map((item, idx) => (
                    <div key={idx} className="p-3 flex justify-between">
                      <span className="font-medium">{item.product_name}</span>
                      <span className="text-emerald-600">{item.quantity} {item.unit}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <Label className="text-gray-500">Belgeler ({detailData.documents?.length || 0})</Label>
                <div className="mt-2 space-y-2">
                  {detailData.documents?.map((doc, idx) => (
                    <div key={idx} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                      <span className="text-sm">{doc.name}</span>
                      {doc.data && (
                        <a 
                          href={doc.data} 
                          download={doc.name}
                          className="text-emerald-600 hover:text-emerald-700 text-sm"
                        >
                          İndir
                        </a>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {detailData.description && (
                <div>
                  <Label className="text-gray-500">Açıklama</Label>
                  <p className="mt-1 text-gray-700">{detailData.description}</p>
                </div>
              )}
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setDetailModal(false)}>Kapat</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Ürün Giriş Geçmişi Modal */}
      <Dialog open={productHistoryModal} onOpenChange={setProductHistoryModal}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Package className="h-5 w-5 text-emerald-600" />
              {selectedProductHistory.product_name} - Giriş Geçmişi
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            {/* Özet Bilgi */}
            <div className="grid grid-cols-3 gap-4 p-4 bg-gray-50 rounded-lg">
              <div>
                <Label className="text-gray-500 text-xs">Toplam Giriş</Label>
                <p className="text-xl font-bold text-emerald-600">
                  {selectedProductHistory.total_quantity} {selectedProductHistory.unit}
                </p>
              </div>
              <div>
                <Label className="text-gray-500 text-xs">Giriş Sayısı</Label>
                <p className="text-xl font-bold text-blue-600">{selectedProductHistory.entry_count}</p>
              </div>
              <div>
                <Label className="text-gray-500 text-xs">Son Giriş</Label>
                <p className="text-sm font-medium">
                  {selectedProductHistory.last_entry_date ? 
                    new Date(selectedProductHistory.last_entry_date).toLocaleDateString('tr-TR') : '-'}
                </p>
              </div>
            </div>

            {/* Giriş Listesi */}
            <div>
              <Label className="text-gray-700 font-medium">Tüm Girişler</Label>
              <div className="mt-2 border rounded-lg divide-y max-h-[400px] overflow-y-auto">
                {selectedProductHistory.entries?.map((entry, idx) => (
                  <div key={idx} className="p-3 hover:bg-gray-50">
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="font-medium text-emerald-600">
                          +{entry.quantity} {entry.unit}
                        </p>
                        <p className="text-sm text-gray-500">
                          {new Date(entry.date).toLocaleString('tr-TR')}
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="text-sm font-medium">{entry.cari_hesap}</p>
                      </div>
                    </div>
                    {entry.description && (
                      <p className="text-xs text-gray-500 mt-2 italic">"{entry.description}"</p>
                    )}
                    {/* Belgeler */}
                    {entry.documents?.length > 0 && (
                      <div className="mt-2 pt-2 border-t">
                        <p className="text-xs text-gray-500 mb-1">Belgeler ({entry.documents.length}):</p>
                        <div className="flex flex-wrap gap-2">
                          {entry.documents.map((doc, docIdx) => (
                            <div key={docIdx} className="flex items-center gap-1 bg-gray-100 rounded px-2 py-1">
                              <span className="text-xs text-gray-700">{doc.name}</span>
                              {doc.data && (
                                <>
                                  <a 
                                    href={doc.data} 
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:text-blue-700 text-xs ml-1"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    Görüntüle
                                  </a>
                                  <span className="text-gray-300">|</span>
                                  <a 
                                    href={doc.data} 
                                    download={doc.name}
                                    className="text-emerald-600 hover:text-emerald-700 text-xs"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    İndir
                                  </a>
                                </>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setProductHistoryModal(false)}>Kapat</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Şifre Doğrulama Modalı */}
      <Dialog open={passwordModal} onOpenChange={setPasswordModal}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Lock className="h-5 w-5 text-amber-600" />
              Şifre Doğrulama
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              Bu işlemi gerçekleştirmek için şifre girmeniz gerekmektedir.
            </p>
            <div>
              <Label>Şifre *</Label>
              <Input
                type="password"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
                placeholder="Şifreyi girin..."
                onKeyDown={(e) => e.key === 'Enter' && handlePasswordConfirm()}
                data-testid="password-input"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setPasswordModal(false)}>İptal</Button>
            <Button onClick={handlePasswordConfirm} className="bg-amber-600 hover:bg-amber-700" data-testid="password-confirm-btn">
              Onayla
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DepotEntry;
